// @flow
import * as React from "react";

import {css, StyleSheet} from "aphrodite";
import Spring from "./Spring";
import GithubButton from "./GithubButton";
import LinkedinButton from "./LinkedinButton";
import TwitterButton from "./TwitterButton";

const SocialMediaContainer = () => (
    <section className={css(styles.socialMediaContainer)}>
        <Spring />
        <GithubButton />
        <LinkedinButton />
        <TwitterButton />
        <Spring />
    </section>
);

const translateKeyFrames = {
        '0%': {
                opacity: 0,
        },
        '100%': {
                opacity: 1,
        },
};

const styles = StyleSheet.create({
        socialMediaContainer: {
                paddingTop: 20,
                display: "flex",
                flexDirection: "row",
                animationName: [translateKeyFrames],
                animationDuration: `3000ms`,
                animationDelay: `4500ms`,
                animationIterationCount: 1,
                animationFillMode: "both",
                transformOrigin: "center",
                perspectiveOrigin: "center",
        },
});

export default SocialMediaContainer;
